import axios from 'axios';
export const instance = axios.create({
    baseURL: '',
    headers: {},
});
export const api = {
    get: function apiGet(url, options) {
        return instance.get(url, options);
    },
    post: function apiPost(url, data, options) {
        return instance.post(url, data, options);
    },
    put: function apiPut(url, data, options) {
        return instance.put(url, data, options);
    },
    patch: function apiPatch(url, data, options) {
        return instance.patch(url, data, options);
    },
    delete: function apiDelete(url, options) {
        return instance.delete(url, options);
    },
};
export default api;
